import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        loaderDiv: css`
            display: flex;
            flex-direction: column;
        `,
        button: css`
            ${custom.button};
            width: auto;
            margin: 20px 25px;
            padding: 10px 20px;
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
        `,
        timeOutLoader: css`
            position: relative;
            padding: 20px 0;
        `,
        stateText: css`
            padding: 20px;
        `,
        centeredText: css`
            padding: 20px;
            align-self: center;
        `,
    }
}

export default styles
